<template>
  <q-banner class="banner rounded-borders text-indigo-10" dense>
    <div class="row items-start no-wrap" :class="{ 'text-no-wrap': !wrap }">
      <div><q-icon class="icon q-mr-sm" :name="icon" size="xs" /></div>
      <div><slot /></div>
    </div>
  </q-banner>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ icon?: string; wrap?: boolean }>(), {
  icon: 'info',
});
</script>

<style scoped lang="scss">
.banner {
  border: 1px solid $light-blue-2;
  background: #eff4ff;
}

.icon {
  top: -1px;
  position: relative;
}
</style>
